import { render, staticRenderFns } from "./header-logo.vue?vue&type=template&id=c2d4fc9e&scoped=true&"
var script = {}
import style0 from "./header-logo.vue?vue&type=style&index=0&id=c2d4fc9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d4fc9e",
  null
  
)

export default component.exports